module.exports = "//d274d294w9cx2v.cloudfront.net/6b04e1f977b82d749f32ecde25a45e1277254c73/images/photo-couple.png";